module.exports = __webpack_public_path__ + "img/preview.bac4b744.jpg";